import Search from '../components/Search'
import QuickFind from '../components/QuickFind'

export default {
  components: {
    'search': Search,
    'quick-find': QuickFind
  },
  data () {
    return {
      search: {
        findLicenseByOption: 'SerialNumber',
        searchInput: '',
        dateOption: 'StartDate',
        licenseTypeOption: 'active',
        fromDateValue: '',
        toDateValue: '',
        showAdvancedSearch: false
      }
    }
  },
  methods: {
    handleFindLicenseByChange (value) {
      this.search.findLicenseByOption = value
    },
    handleSearchInputChange (value) {
      this.search.searchInput = value
    },
    handleOrderDateChange (value) {
      this.search.dateOption = value
    },
    handleLicenseTypeChange (value) {
      this.search.licenseTypeOption = value
    },
    handleFromDateChange (value) {
      this.search.fromDateValue = new Date(value).toISOString()
    },
    handleToDateChange (value) {
      this.search.toDateValue = new Date(value).toISOString()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SearchMixin.js